import { useEffect, useState } from "react";
import LabelInput from "../../../Component/labelInput";
import PageTitle from "../../../module/pageTitle";
import { InputField, Submitbtn } from "../../../Component";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../store";
import {
  emailCheck,
  hasWhiteSpace,
  startsWithSpace,
} from "../../../Utils/validators";
import { createUser, getRoleList } from "../adminSlice";
import DropdownWithClear from "../../../Component/dropdownWithClear";
import { loginTypeList } from "../../../Utils/dataConstant";
import { showSnackbar, hideSnackbar } from "../../../store/slices/snackbarSlice";

const CreateUser = () => {
  const dispatch: Function = useDispatch<AppDispatch>();

  const [name, setName] = useState<any>("");
  const [email, setEmail] = useState<any>("");
  const [userName, setUserName] = useState<any>("");
  const [password, setPassword] = useState<any>("");
  const [role, setRole] = useState<any>("");
  const [roleList, setRoleList] = useState<any>([]);
  const [loginType, setLoginType] = useState<any>("");

  useEffect(() => {
    dispatch(
      getRoleList({
        callback: (res: any) => {
          setRoleList(res?.data);
        },
        errorCallback: () => { },
      })
    );
  }, []);
  const onchangeName = (value: any) => {
    setName(value);
  };
  const onchangeUserName = (value: any) => {
    setUserName(value);
  };
  const onchangePassword = (value: any) => {
    setPassword(value);
  };

  const onchangeEmail = (value: any) => {
    if (!startsWithSpace(value) && !hasWhiteSpace(value)) {
      setEmail(value);
    } else {
      return;
    }
  };
  function allemail(inputtxt: any) {
    if (email.match(emailCheck)) {
      return true;
    } else {
      return false;
    }
  }
  const onchangeRole = (value: any) => {
    setRole(value);
  };
  const onchangeLoginType = (value: any) => {
    setLoginType(value);
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    const postData = {
      name: name,
      username: userName,
      password: password,
      role: role?.name,
      status: 1,
      loginType: loginType?._id,
    };
    dispatch(
      createUser({
        params: postData,
        callback: (res: any) => {
          if (res?.length > 0) {
            setName("");
            setUserName("");
            setPassword("");
            setRole("");
            setLoginType("");
            setEmail("");
            dispatch(showSnackbar({ message: res?.msg, type: res?.type }));
            setTimeout(() => {
              hideSnackbar();
            }, 5000);
          }
        },
        errorCallback: (error: any) => {
          dispatch(showSnackbar({ message: error?.data?.msg, type: error?.data?.type }));
          setTimeout(() => {
            hideSnackbar();
          }, 5000);
        },
      })
    );
  };
  const validations = () => {
    let valid = false;

    if (
      name === "" ||
      userName === "" ||
      password === "" ||
      email === "" ||
      role === "" ||
      loginType === ""
    ) {
      valid = true;
    }
    return valid;
  };
  return (
    <div className="panel-content">
      <div className="mb-4">
        <PageTitle name={"Create User"} />
      </div>
      <div className="formDiv">
        <div className="bxshadow p-2 borderRadius mb-4 ">
          <form onSubmit={handleSubmit}>
            <div className="row ">
              <div className="col-md-4 mb-3">
                <LabelInput labelName={"Name"} isRequired />
                <InputField
                  placeholder={"Enter Name"}
                  setInputText={(value: any) => onchangeName(value)}
                  value={name}
                />
              </div>
              <div className="col-md-4 mb-3">
                <LabelInput labelName={"User Name"} isRequired />
                <InputField
                  placeholder={"Enter User Name"}
                  setInputText={(value: any) => onchangeUserName(value)}
                  value={userName}
                />
              </div>

              <div className="col-md-4 mb-3">
                <LabelInput labelName={"Password"} isRequired />
                <InputField
                  placeholder={"Enter Password"}
                  setInputText={(value: any) => onchangePassword(value)}
                  value={password}
                />
              </div>

              <div className="col-md-4 mb-3">
                <LabelInput labelName={"Email"} isRequired />
                <InputField
                  placeholder={"Enter Email"}
                  setInputText={(value: any) => onchangeEmail(value)}
                  value={email}
                />
              </div>
              <div className="col-md-4 mb-3">
                <LabelInput labelName={"Role"} isRequired />
                <DropdownWithClear
                  labelName={"Select Role"}
                  setInputText={(value: any) => onchangeRole(value)}
                  options={roleList}
                  value={role}
                />
              </div>
              <div className="col-md-4 mb-3">
                <LabelInput labelName={"Login Type"} isRequired />
                <DropdownWithClear
                  labelName={"Select Login Type"}
                  setInputText={(value: any) => onchangeLoginType(value)}
                  options={loginTypeList}
                  value={loginType}
                />
              </div>

              <div className="d-flex justify-content-center mt-3">
                <div className="col-2 pt-2">
                  <Submitbtn name={"Submit"} disabled={validations()} />
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CreateUser;
